<template>
  <div id="weightModal1234">
    <!-- <b-row>
      <b-col sm="3">항목</b-col>
      <b-col sm="9">세부 내용</b-col>
    </b-row> -->
    <b-row style="padding-bottom:10px;">
      <b-col sm="3">배너 사이즈</b-col>
      <b-col sm="2">
        <div>
          <b-form-input :class="{error: errors.has('bannerWidth')}" :name="'bannerWidth'"
          v-validate="'required|min:1'" min=0 v-model="formData.bannerWidthStr" type="number" ></b-form-input>
        </div>
      </b-col>
      <b>X</b>
      <b-col sm="2">
        <div>
          <b-form-input :class="{error: errors.has('bannerHeight')}" :name="'bannerHeight'"
          v-validate="'required|min:1'" min=0 v-model="formData.bannerHeightStr"type="number" ></b-form-input>
        </div>
      </b-col>
      <b-col sm="4">
        {{formData.bannerMsg}}
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">배너 형태</b-col>
      <b-col sm="9">
        <b-form-group>
          <b-form-radio-group
            v-model="formData.optionASelected"
            :options="optionA"
            name="radio-inlineA"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">싸이트 적용 위치</b-col>
      <b-col sm="9">
        <b-form-group>
          <b-form-radio-group
            v-model="formData.optionBSelected"
            :options="optionB"
            name="radio-inlineB"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">싸이트 적용 위치2</b-col>
      <b-col sm="9">
        <b-form-group>
          <b-form-radio-group
            v-model="formData.optionCSelected"
            :options="optionC"
            name="radio-inlineC"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">운동성(배너 변화)</b-col>
      <b-col sm="9">
        <b-form-group>
          <b-form-radio-group
            v-model="formData.optionDSelected"
            :options="optionD"
            name="radio-inlineD"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">광고 소재</b-col>
      <b-col sm="9">
        <b-form-group>
          <b-form-radio-group
            v-model="formData.optionESelected"
            :options="optionE"
            name="radio-inlineE"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import numeral from 'numeral';
import WeightDB from "../../common/WeightDB.js";
export default {
    name: "Weight",
    filters:{

    },
    components:{
    },
    props: {
      formData:null,
    },
    data() {
        return {
          id: '',
          optionA: [
            { text: '일반', value: '일반'},
            { text: '확장형', value: '확장형' },
            { text: '팝업', value: '팝업' },
            { text: '전면', value: '전면' },
          ],
          optionB: [
            { text: '최상단', value: '최상단' },
            { text: '중간', value: '중간' },
            { text: '하단', value: '하단' },
          ],
          optionC: [
            { text: '메인', value: '메인' },
            { text: '서브', value: '서브' },
            { text: '팝업', value: '팝업' },
          ],
          optionD: [
            { text: '일반', value: '일반' },
            { text: '확장형', value: '확장형' },
            { text: '팝업', value: '팝업' },
          ],
          optionE: [
            { text: '이미지', value: '이미지' },
            { text: '텍스트', value: '텍스트' },
            { text: '이미지+동영상', value: '이미지동영상' },
          ],
        }
    },
    watch:{
      'formData.bannerWidthStr':function(){
        var size = parseInt(this.formData.bannerWidthStr) * parseInt(this.formData.bannerHeightStr);
        if(this.formData.media == 'PC'){
          if(size <= parseInt(WeightDB.data.device.pcStatic) && size > 0 ){
            this.formData.bannerMsg = ''
          }else{
            this.formData.bannerMsg = 'PC의 배너크기는 ' + WeightDB.data.device.pcStatic +'를 넘을 수 없습니다.'
          }
        }else if(this.formData.media == 'Mobile'){
          if(size <= parseInt(WeightDB.data.device.moStatic) && size > 0 ){
            this.formData.bannerMsg = ''
          }else{
            this.formData.bannerMsg = 'Mobile의 배너크기는 ' + WeightDB.data.device.moStatic +'를 넘을 수 없습니다.'
          }
        }
      },
      'formData.bannerHeightStr':function(){
        var size = parseInt(this.formData.bannerWidthStr) * parseInt(this.formData.bannerHeightStr);
        if(this.formData.media == 'PC'){
          if(size <= parseInt(WeightDB.data.device.pcStatic) && size > 0 ){
            this.formData.bannerMsg = ''
          }else{
            this.formData.bannerMsg = 'PC의 배너크기는 ' + WeightDB.data.device.pcStatic +'를 넘을 수 없습니다.'
          }
        }else if(this.formData.media == 'Mobile'){
          if(size <= parseInt(WeightDB.data.device.moStatic) && size > 0 ){
            this.formData.bannerMsg = ''
          }else{
            this.formData.bannerMsg = 'Mobile의 배너크기는 ' + WeightDB.data.device.moStatic +'를 넘을 수 없습니다.'
          }
        }
      },
    },
    created: function() {
      this.id = this._uid + "_";
    },
    mounted() {
      // var self = this;
      // setTimeout(function(){
      //   self.formData.optionASelected = '일반',
      //   self.formData.optionBSelected = '최상단',
      //   self.formData.optionCSelected = '메인',
      //   self.formData.optionDSelected = '일반',
      //   self.formData.optionESelected = '이미지',
      //   self.formData.bannerWidthStr = '1024',
      //   self.formData.bannerHeightStr = '1080'
      // }, 1000);
    },
    methods:{

    }
}
</script>
<style scoped>
#genderGroup .btn.active {
  color: #fff;
  border: 1px solid #428bca !important;
}

#ageGroup .btn.active {
  color: #fff;
  border: 1px solid #049372 !important;
}

.btn-age-group-lg {
  width: 234px;
  margin-right: 11px;
  font-weight: 600;
}

.btn-age-group-sm {
  width: 65px;
  margin-right: 5px;
  margin-bottom: 3px;
  font-weight: 600;
}
</style>
<style>
#weightModal1234 .custom-control-inline{
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/views/reach/da/WeightModal.vue